<!-- 出生月份 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="birthMonth" type="birthMonth" clearable/>
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-出生月份',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '出生月份：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const birthMonth = useQuery('birthMonth', props.value);

    return {
      birthMonth,
    };
  },
};
</script>
